<template>
  <div>
  <el-col :span="24" class="header">
    <el-col :xl="3" :lg="5" :offset="1">
      <span class="header-title">ESG Portal <span class="environment">{{environment}}</span></span>
    </el-col>
    <el-col :xl="2" :lg="2">&nbsp;</el-col>
    <el-col :span="8" class="esg-menu">
      <!-- :span="6" :md="4" :xl="4" :lg="5"-->
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelect"
               background-color="#5e89ed" text-color="#fff" active-text-color="#ffdc73">
      <el-submenu index="1" v-if="isVendorOrAdmin">
        <template slot="title">Vendor</template>
        <el-menu-item index="vendorCategoryMaintenance" v-if="user.role === roleVendor || user.role === roleAdmin">Category Maintenance</el-menu-item>
        <el-menu-item index="vendorMaintenance">Vendor Maintenance</el-menu-item>
        <el-menu-item index="vendorAssessment" v-if="user.role === roleVendor || user.role === roleAdmin">Assessment Maintenance</el-menu-item>
        <el-menu-item index="assessmentResult">Assessment Result</el-menu-item>
        <el-menu-item index="regionalAccountMaintenance" v-if="user.role === roleVendor || user.role === roleAdmin">Regional Account Maintenance</el-menu-item>
      </el-submenu>
      <el-submenu index="2" v-if="user.role === roleStakeholder || user.role === roleAdmin">
        <template slot="title">Stakeholder</template>
        <el-menu-item index="categoryMaintenance">Category Maintenance</el-menu-item>
        <el-menu-item index="stakeholderMaintenance">Stakeholder Maintenance</el-menu-item>
        <el-menu-item index="stakeholderQuestionnaire">Questionnaire Maintenance</el-menu-item>
        <el-menu-item index="questionnaireResult">Questionnaire Result</el-menu-item>
      </el-submenu>
      <el-menu-item index="reportMaintenance" v-if="user.role === roleAdmin">
        <template slot="title">Report</template>
      </el-menu-item>
      </el-menu>
    </el-col>
    <el-col :xl="10" :lg="6">&nbsp;</el-col>
    <el-col :xl="2" :lg="3" class="header-welcome">Welcome  {{user.domain}}</el-col>
    <el-col :xl="2" :lg="3" class="text-align-right">
      <img src="../assets/OOCL_white.png" class="oocl-logo">
    </el-col>
    <el-col :xl="1" :lg="1">&nbsp;</el-col>
  </el-col>
  <UserGuide></UserGuide>
  </div>
</template>

<script>
import Constant from '@/common/Constant'
import { verifyUserInfo } from '@/services/login.service'
import UserGuide from './UserGuide';
import headerService from '@/services/header.service';

export default {
  components: {UserGuide},
  data () {
    return {
      activeIndex: '1',
      activeIndex2: '1',
      roleVendor: Constant.USER_TYPE_VENDOR,
      roleStakeholder: Constant.USER_TYPE_STAKEHOLDER,
      roleAdmin: Constant.USER_TYPE_ADMIN,
      roleRegionVendor: Constant.USER_TYPE_REGION_VENDOR,
      isVendorOrAdmin: false,
      user: {},
      environment: ''
    };
  },
  methods: {
    async initUserName () {
      this.user = await verifyUserInfo();

      if (this.user.role === this.roleAdmin || this.user.role === this.roleVendor || this.user.role === this.roleRegionVendor) {
        this.isVendorOrAdmin = true;
      }
    },
    handleSelect (key, keyPath) {
      switch (key) {
        case 'vendorCategoryMaintenance':
          this.$router.push({name: 'VendorCategoryMaintenance'});
          break;
        case 'vendorMaintenance':
          this.$router.push({name: 'VendorMaintenance'});
          break;
        case 'vendorAssessment':
          this.$router.push({name: 'VendorAssessment'});
          break;
        case 'assessmentResult':
          this.$router.push({name: 'VendorAssessmentResult'});
          break;
        case 'categoryMaintenance':
          this.$router.push({name: 'CategoryMaintenance'});
          break;
        case 'stakeholderMaintenance':
          this.$router.push({name: 'StakeholderMaintenance'});
          break;
        case 'stakeholderQuestionnaire':
          this.$router.push({name: 'StakeholderQuestionnaire'});
          break;
        case 'questionnaireResult':
          this.$router.push({name: 'StakeholderQuestionnaireResult'});
          break;
        case 'regionalAccountMaintenance':
          this.$router.push({name: 'RegionalAccountMaintenance'});
          break;
        case 'reportMaintenance':
          this.$router.push({name: 'ReportMaintenance'});
          break;
      }
    }
  },
  created () {
    this.initUserName();
    headerService.findEnvironment().then(res => {
      if (res.data) {
        this.environment = '(' + res.data + ')';
      }
    });
  }
  // mounted () {
  //   this.initUserName();
  // }
};
</script>

<style scoped>
.header{
  background-color: #5e89ed;
  height: 60px;
  position: fixed;
  z-index: 10;
}
.oocl-logo{
  height: 35px;
  padding-top: 15px;
  padding-right: 10px;
}
.header-title{
  color: #fff;
  font-weight: bold;
  font-size: 26px;
  position: relative;
  top: 15px;
}

.text-align-right{
  position: fixed;
  right: 3%;
  text-align: right;
}

.esg-menu{
  position: relative;
}

@media screen and (max-width: 1141px) {
  .el-menu-demo{
    position: fixed;
    margin-right: 10%;
  }
}

@media screen and (max-width: 1230px) {
  .header-welcome{
    font-size: 13px;
  }
}

.header-welcome{
  position: fixed;
  right: 15%;
  margin-right: 15px;
  color: #fff;
  padding-top: 20px;
  text-align: right;
}

/*rewrite element-ui */
>>>.el-submenu__title{
    font-size: 16px
}
.environment {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue